import { Close, ExpandMore } from '@mui/icons-material/';
import { Box, Card, CardActions, Collapse, IconButton, Paper, Typography } from '@mui/material';
import clsx from 'clsx';
import React, { useState } from 'react';

import { snackMessageStyles } from '../style';
import { DetailedSnackMessageProps } from '../types';
import { getNotificationClass, getNotificationTypeIcon } from '../util';

const DetailedSnackMessage = React.forwardRef<any, DetailedSnackMessageProps>(
  ({ message, closeSnackbar, variant, Content }, ref) => {
    const classes = snackMessageStyles();
    const [expanded, setExpanded] = useState(false);

    const handleDismiss = (event: React.MouseEvent<HTMLElement>) => {
      event.stopPropagation();
      closeSnackbar();
    };

    const handleExpand = (event: React.MouseEvent<HTMLElement>) => {
      event.stopPropagation();
      setExpanded(!expanded);
    };

    return (
      <Card className={classes.card} ref={ref}>
        <CardActions className={getNotificationClass(variant, classes)}>
          <Box className={classes.notificationMessageContainer}>
            <Box
              className={`${getNotificationClass(variant, classes)} ${classes.notificationMessage}`}
            >
              {getNotificationTypeIcon(variant)}
            </Box>
            <Typography variant='body2' className={classes.notificationMessage}>
              {message}
            </Typography>
          </Box>
          <Box className={classes.icons}>
            <IconButton
              className={clsx(classes.expand, { [classes.expandOpen]: expanded })}
              onClick={handleExpand}
            >
              <ExpandMore />
            </IconButton>
            <IconButton className={classes.expand} onClick={handleDismiss} size='small'>
              <Close fontSize='small' />
            </IconButton>
          </Box>
        </CardActions>
        <Collapse in={expanded} timeout='auto' unmountOnExit>
          <Paper className={classes.collapse}>{Content}</Paper>
        </Collapse>
      </Card>
    );
  }
);

export default DetailedSnackMessage;
